import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteRfidCard() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => {
      if (id) {
        return api.delete(`rfidCards/${id}`);
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['rfidCards'] }),
  });
}
